import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const TopProductsChart = ({ data, title }) => {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <h3>{title}</h3>
      <ResponsiveContainer>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#00ff00" />
          <XAxis dataKey="productName" stroke="#00ff00" />
          <YAxis stroke="#00ff00" />
          <Tooltip contentStyle={{ backgroundColor: '#111', borderColor: '#00ff00' }} />
          <Legend />
          <Bar dataKey="clickCount" fill="#ff0" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopProductsChart;